export default __webpack_public_path__ + "static/media/block.f142ddf6.svg";